module.exports = __webpack_public_path__ + "img/icon-download.38309736.png";